import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import type { FencingStock } from './models/JobInterfaces';

interface NewJobFencingProps {
    showModal: boolean;
    fencingStock: FencingStock;
    update(fencingStock: FencingStock): void;
    hideModal(): void;
    saveModal(): void;
}

const NewJobPricelistFencingStockData = (props: NewJobFencingProps) => {
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    const handleChange = (e: any) => {
        setErrors({});

        let item: any = {};
        item = props.fencingStock;
        item[e.target.name] = e.target.value;

        props.update(item);
    }

    const validate = () => {
        var errorList: { [key: string]: string } = {};
        var formIsValid = true;

        if (props.fencingStock.panels < 1) {
            formIsValid = false;
            errorList["panels"] = "Number of Panels is required";
        }

        setErrors(errorList);

        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.saveModal();
        } else {
            toast.error("Please fix validation errors before Saving!");
        }
    }

    return (
        <Modal show={props.showModal} onHide={props.hideModal} backdrop="static">
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Enter Fencing Stock on Site</Modal.Title>
                <button type="button" className="close" onClick={props.hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <label className="input-group" htmlFor="panels">
                    <span className="label">Panels</span>
                    <input className="input" min={0} step={1} type="number" id="panels" name="panels" value={props.fencingStock.panels} onChange={(e) => handleChange(e)}></input>
                </label>
                <span className={errors["panels"] ? "label marginLeftLabel errors" : "hidden"}>{errors["panels"]}</span>

                <label className="input-group" htmlFor="blocks">
                    <span className="label">Blocks</span>
                    <input className="input" min={0} step={1} type="number" id="blocks" name="blocks" value={props.fencingStock.blocks} onChange={(e) => handleChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="clamps">
                    <span className="label">Clamps</span>
                    <input className="input" min={0} step={1} type="number" id="clamps" name="clamps" value={props.fencingStock.clamps} onChange={(e) => handleChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="pickets">
                    <span className="label">Pickets</span>
                    <input className="input" min={0} step={1} type="number" id="pickets" name="pickets" value={props.fencingStock.pickets} onChange={(e) => handleChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="signs">
                    <span className="label">Signs</span>
                    <input className="input" min={0} step={1} type="number" id="signs" name="signs" value={props.fencingStock.signs} onChange={(e) => handleChange(e)}></input>
                </label>
                <label className="input-group" htmlFor="braces">
                    <span className="label">Braces</span>
                    <input className="input" min={0} step={1} type="number" id="braces" name="braces" value={props.fencingStock.braces} onChange={(e) => handleChange(e)}></input>
                </label>
                
            </Modal.Body>
            <Modal.Footer>
                <button className="popup-button--yes" onClick={save}>Save</button>
            </Modal.Footer>
        </Modal>
    )
}

export default NewJobPricelistFencingStockData;